import script from "./AccessLog.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessLog.vue?vue&type=script&setup=true&lang=js"

import "./AccessLog.vue?vue&type=style&index=0&id=36709b52&lang=less&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36709b52"]])

export default __exports__